import { useState } from 'react'
import { getPlaceholderIcon, getTypeLabel, listContentUrlHref } from  '@/helpers/Content'
import LoadingSpinner from '../search/LoadingSpinner/LoadingSpinner';
import { getImageAsset } from  '@/helpers/Images';



const ListContentTile = ({item, appGuid, listId, status, archiveStatus, isNotALink}:{item: any, appGuid: string, listId: string, status: any, archiveStatus: JSX.Element | string, isNotALink?: boolean}) => {
    const [hasError, setHasError] = useState(false);
    const [isLoading, setIsLoading] = useState(true);

    const content = (
        <>
            {((item.featuredImageUrl || item?.featuredImage?.url) && !hasError)
                ?   <img className='featured-image' src={getImageAsset(60, item.featuredImageUrl ?? item?.featuredImage?.url)} alt="" onError={() => {setHasError(true); setIsLoading(false)}} onLoad={() => setIsLoading(false)} />
                :   <div className='placeholder-wrapper'>
                        {(isLoading && (item.featuredImageUrl ?? item?.featuredImage?.url))
                            ?   (<LoadingSpinner size={18}/> )
                            :   <img className='placeholder-image' src={getPlaceholderIcon(item.type)} alt=""/>
                        }
                    </div>
            }

            <div className='list-content-title-container'>
                <span className='page-title'>{item.title}</span>
                <span className='page-type-and-status'>
                    {status}
                    <span className='type-text'>{getTypeLabel(item.type ?? item.contentType)}</span>
                    {!!archiveStatus && archiveStatus }
                </span>
            </div>
        </>
    )

    if (isNotALink) {
        return <div className="list-content-title-square">{content}</div>
    }

    return (
        <a
            className="list-content-title-square"
            href={listContentUrlHref(appGuid, item.id, listId)}
        >
        {content}
        </a>
    )
}

export default ListContentTile